import { Stack } from '@mui/material';
import { Form, FormRef } from 'common/form';
import { useEffect, useRef, useState } from 'react';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { mapSearchPeoplePayloadToFilters } from 'modules/sourcing-external/utils/mapSearchPeoplePayload';
import { SourcingExternalSearchFilterFormData } from 'modules/sourcing-external/forms/schemas/sourcingExternalSearchFilterSchema';
import {
  getSourcingExternalSearchFilterFields,
  sourcingExternalSearchFormGroups
} from 'modules/sourcing-external/forms/fields/getSourcingExternalSearchFilterFields';
import { sourcingExternalSearchFilterSchema } from 'modules/sourcing-external/forms/schemas/sourcingExternalSearchFilterSchema';

export const SourcingExternalSearchFilter = () => {
  const formRef = useRef<FormRef<SourcingExternalSearchFilterFormData>>(null);
  const searchQueryInput = useSourcingExternalStore(
    (state) => state.searchQueryInput
  );
  const updateSearchFilters = useSourcingExternalStore(
    (state) => state.updateSearchFilters
  );
  const [isExcludeCompaniesSelected, setIsExcludeCompaniesSelected] =
    useState(false);
  const [isExcludeJobTitlesSelected, setIsExcludeJobTitlesSelected] =
    useState(false);

  useEffect(() => {
    if (!formRef?.current) {
      return;
    }

    const subscription = formRef.current.watch((value: any, { name }: any) => {
      if (name === 'excludeCompanies') {
        setIsExcludeCompaniesSelected(!!value.excludeCompanies);
      }
      if (name === 'excludeJobTitles') {
        setIsExcludeJobTitlesSelected(!!value.excludeJobTitles);
      }
    });

    return () => subscription.unsubscribe();
  }, [formRef?.current?.watch]);

  useEffect(() => {
    if (!searchQueryInput) return;

    if (
      searchQueryInput.exclude_companies &&
      searchQueryInput.exclude_companies.length > 0
    ) {
      setIsExcludeCompaniesSelected(true);
    }
    if (
      searchQueryInput.exclude_job_titles &&
      searchQueryInput.exclude_job_titles.length > 0
    ) {
      setIsExcludeJobTitlesSelected(true);
    }
  }, [
    searchQueryInput?.exclude_companies,
    searchQueryInput?.exclude_job_titles
  ]);

  const onSubmit = (filters: SourcingExternalSearchFilterFormData) => {
    updateSearchFilters(filters);
  };

  return (
    <Stack
      sx={{
        backgroundColor: 'customGrey.light',
        width: '440px',
        p: '20px',
        pb: '40px'
      }}
    >
      <Form
        ref={formRef}
        defaultValues={
          searchQueryInput
            ? mapSearchPeoplePayloadToFilters(searchQueryInput)
            : {
                currentTitlesOnly: true
              }
        }
        schema={sourcingExternalSearchFilterSchema}
        fields={getSourcingExternalSearchFilterFields({
          isExcludeCompaniesSelected,
          isExcludeJobTitlesSelected
        })}
        groups={sourcingExternalSearchFormGroups}
        submitButtonProps={{
          label: 'Find candidates',
          sx: {
            width: '100%'
          }
        }}
        onSubmit={onSubmit}
      />
    </Stack>
  );
};
